import { render, staticRenderFns } from "./AwsLambdaFiles.vue?vue&type=template&id=f89ed230&"
import script from "./AwsLambdaFiles.vue?vue&type=script&lang=js&"
export * from "./AwsLambdaFiles.vue?vue&type=script&lang=js&"
import style0 from "./AwsLambdaFiles.vue?vue&type=style&index=0&id=f89ed230&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports